import {
  activeFeedbackTabSelector,
  feedbacksSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { FeedbackType } from '@chegg-wt/core-wa/types'
import { adjustFeedbacksInRedux } from '@chegg-wt/core-wa/components/CardsContainer/SuggestionTabs/utils'
import { appendFeedback, setActiveFeedbackCardId } from '@chegg-wt/core-wa/state/actions'
import getFeatureEditor from '../../getEditor'
import { HistoryDeltaAction, UndoFeedbackDeltaParams } from '../types'
import { getFeedbackPosition } from '../../helpers'
import {
  getFeedbackKeyFromPosition,
  getKeyFromSentence,
  openSameTab,
} from './commonUtils'

export const undoFeedbackDelta = ({
  feedbackDelta,
  dispatch,
  state,
  removedGrammarCards,
  removedParaphraseCards,
}: UndoFeedbackDeltaParams) => {
  const editor = getFeatureEditor()
  feedbackDelta.forEach((delta) => {
    const { feedback, action } = delta
    const activeFeedbackTab = activeFeedbackTabSelector(state)
    const sentenceOffsets = sentenceOffsetsSelector(state)
    const feedbackPosition = getFeedbackPosition(feedback, sentenceOffsets)
    editor.commands.clearAllHighlights()
    if (
      action === HistoryDeltaAction.APPLY &&
      feedback.feedbackType === FeedbackType.GRAMMAR
    ) {
      // We need to adjust grammar offsets in this case
      const feedbacks = feedbacksSelector(state)
      const appliedFeedback = {
        ...feedback,
        impactedText: feedback.suggestedText,
      }
      appliedFeedback.suggestedText = ' '.repeat(appliedFeedback.position.length) // Only length is used in adjustFeedbacksInRedux, text not matter
      adjustFeedbacksInRedux(feedbacks, appliedFeedback, dispatch)
    }
    dispatch(appendFeedback([feedback]))
    openSameTab(feedback.feedbackType, activeFeedbackTab, dispatch)
    const endCursorPosition = feedbackPosition.offset + feedbackPosition.length
    editor
      .chain()
      .setCustomUnderline({
        id: feedback.id,
        offset: feedbackPosition.offset,
        length: feedbackPosition.length,
        type: feedback.feedbackType,
      })
      .setTextSelection({ from: endCursorPosition, to: endCursorPosition })
      .scrollIntoView()
      .run()
    dispatch(setActiveFeedbackCardId(feedback.id))

    if (action === HistoryDeltaAction.DISCARD) {
      // Special case to handle discard
      const sentence = sentenceOffsets.find(
        (sentence) => sentence.id === feedback.sentenceId
      )
      const key = getKeyFromSentence(feedback.sentenceId, sentence.originalText)
      if (feedback.feedbackType === FeedbackType.GRAMMAR) {
        const { position } = feedback
        removedGrammarCards.get(key).delete(getFeedbackKeyFromPosition(position))
        if (!removedGrammarCards.get(key).size) removedGrammarCards.delete(key)
      } else removedParaphraseCards.delete(key)
    }
  })
}
